import { connectedStore } from '../../store';
import site from '../../site';
import getBlock from '../selectors/block';
import isBlockOnPage from './is-block-on-page';

const isReloadRequired = (blockId) => {
  const store = connectedStore.get();
  const state = store.getState();
  const block = getBlock(state, blockId);
  const pageId = site.selectors.getActivePageId(state);

  return block.reloadView || !isBlockOnPage(blockId, pageId);
};

export default isReloadRequired;
